<app-sidebar [items]="subModuleLinks"></app-sidebar>